import baseService from '@common/services/base.service';
import store from '@common/store/store';

const tbRoute = window.api_routes.smarAPD_Tributario_Domain;

let http = baseService(store, tbRoute);

const apidDef = {
  async getTemplateTelaInicial() {
    var result = await http.get('/SedeExterno/templateTelaInicial');
    return result.data;
  },
};

export default apidDef;
